import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthStatus } from '@bn/primitives';

import { AuthRoutes } from '../enums/auth-routes.enum';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class Auth2faGuard implements CanActivate {
  private readonly router = inject(Router);

  private readonly authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const authData = this.authService.authStoreValue;

    if (authData?.auth_token && authData?.auth_status === AuthStatus.TwoFactorRequired) {
      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate([`/${AuthRoutes.Auth}/${AuthRoutes.Login}`], {
      queryParams: { returnUrl: state.url },
    });

    return false;
  }
}
